import { enqueueSnackbar } from "@powerdiary/components-library/lib/components/Snackbar";

import { AxiosError, AxiosResponse } from "axios";
import { useClientPortalConfigContext } from "../../context";
import { useDeleteMutation } from "hooks/useClientPortalQuery";
import { useAnalytics } from "hooks/useAnalytics";
import { useQueryClient } from "@tanstack/react-query";
import { getAppointmentsQueryUrl } from "./useAppointments";

export function useCancelAppointment() {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { track } = useAnalytics();
    const queryClient = useQueryClient();

    const { mutateAsync } = useDeleteMutation<AxiosResponse, AxiosError, number>({
        url: `/api/v1/${clientPortalGuid}/Appointments/`,
    });

    const cancelAppointment = async (appointmentId: number) => {
        await mutateAsync(appointmentId);
        track("appointment_cancelled", { appointment_id: appointmentId });
        enqueueSnackbar("Appointment successfully cancelled", { variant: "success" });
        await queryClient.invalidateQueries({ queryKey: [getAppointmentsQueryUrl(clientPortalGuid)] });
    };

    return {
        cancelAppointment,
    };
}
